import { Pipe, PipeTransform } from "@angular/core";
import { AttributeItem } from "src/app/users/_interfaces/users-admin";
import { QuestionConfig } from "../interfaces/process-config.interface";

@Pipe({
  name: 'inverseQuestionAttribute'
})
export class InverseQuestionAttributePipe implements PipeTransform {
  transform(questions: QuestionConfig[]): QuestionConfig[] {
     return questions
      ? questions.filter(
        g => !g.attributes
        || g.attributes.length === 0)
      : [];
  }
}
